import { type FC } from 'react';
import { MAX_COMMENT_CHARACTERS } from '@/lib/comments';
import { cn } from '@/lib/utils';

export const CommentCharacterCount: FC<{ normalizedDraft: string; className?: string }> = ({
  normalizedDraft,
  className,
}) => (
  //TODO: Add a Tooltip with the explanation
  <p
    className={cn(
      'text-xs text-text-gray-alternate opacity-100 duration-150',
      {
        'text-status-warning': normalizedDraft.length > MAX_COMMENT_CHARACTERS - 20,
        'text-status-failure': normalizedDraft.length === MAX_COMMENT_CHARACTERS,
        'opacity-0': normalizedDraft.length < MAX_COMMENT_CHARACTERS - 40,
      },
      className,
    )}
    data-cy="comments-character-count"
  >
    {normalizedDraft.length}/{MAX_COMMENT_CHARACTERS}
  </p>
);
